export default {
  namespaced: true,
  bosch: {
    title: "Bosch",
    profiles: "Perfis",
    profile: "Perfil",
    rules: "Regras",
    alarms: "Alarmes",
    panels: "Painéis",
    logs: "Registros",
    panel: "Painel",
    name: "Nome",
    panelHost: "Host do Painel",
    panelPasscode: "Código de Acesso",
    panelInstance: "Instância do Painel",
    panelModel: "Modelo do Painel",
    units: "Instalações",
    center: "Centro",
    sector: "Setor",
    reseller: "Revendedor",
    resellers: "Revendedores",
    status: "Status",
    active: "Ativo",
    actions: "Ações",
    syncStatus: "Sincronizar Status",
    syncActions: "Sincronizar Ações",
    syncDevices: "Sincronizar Dispositivos",
    copyPassword: "Copiar Senha",
    syncing: "Sincronizando...",
    syncCorrectly: "Sincronizado com sucesso",
    connected: "Conectado",
    disconnected: "Desconectado",
    armPanel: "Armar Painel",
    disarmPanel: "Desarmar Painel",
    arming: "Armando...",
    disarming: "Desarmando...",
    armedCorrectly: "Armado com sucesso",
    disarmedCorrectly: "Desarmado com sucesso",
    description: "Descrição",
    deviceType: "Tipo de Dispositivo",
    deviceId: "ID do Dispositivo",
    area: "Área",
    areaId: "ID do Área",
    eventType: "Tipo de Evento",
    userId: "ID do Usuário",
    username: "Nome de Usuário",
    alarmId: "ID do Alarme",
    eventDate: "Data do Evento",
    devices: "Dispositivos",
    panelOffline: "Painel Desconectado",
    panelStatusArmed: "Armado",
    panelStatusDisarmed: "Desarmado",
    panelStatusOffline: "Desconectado",
    eventDefinition: "Definição de Evento",
    eventCode: "Código de Evento",
    alarmType: "Tipo de Alarme",
    typeAlarm: "Tipo de Alarme",
    deviceName: "Nome do Dispositivo",
    dispatchAlarm: "Despachar Alarme",
    wizard: {
      add: {
        title: "Adicionar Painel Bosch"
      },
      edit: {
        title: "Editar Painel Bosch"
      },
      steps: {
        general: "Geral"
      }
    },
    messages: {
      areYouSure: "Tem certeza de que deseja %action% %device_type% %device%?",
      commandExecutedSuccess: "Comando %command% executado com sucesso",
      commandExecutedError: "Erro ao executar o comando %command%",
      executeCommandConfirm: "Executar Comando",
      processing: "Processando..."
    },
    devices: {
      devices: "Dispositivos",
      update: "Atualizar",
      error_loading_devices: "Erro ao carregar dispositivos",
      retry: "Tentar novamente",
      panel_information: "Informações do Painel",
      areas: "Áreas",
      zones: "Zonas",
      outputs: "Saídas",
      doors: "Portas",
      no_devices_found: "Nenhum dispositivo encontrado",
      synchronize_panel_first: "Sincronize o painel primeiro para ver os dispositivos",
      area: "Área",
      zone: "Zona",
      output: "Saída",
      door: "Porta",
      panel: "Painel",
      arm: "Armar",
      disarm: "Desarmar",
      bypass: "Ignorar",
      reset: "Redefinir",
      open: "Abrir",
      close: "Fechar",
      activate: "Ativar",
      deactivate: "Desativar",
      actions_column: "AÇÕES",
      status_column: "STATUS",
      type_column: "TIPO",
      name_column: "NOME",
      device_id_column: "ID DO DISPOSITIVO",
      area_status: "Status da Área",
      sync_devices: "Sincronizar Dispositivos",
      go_back: "Voltar"
    }
  }
}
